import React from 'react';
import { CommunityDashboard } from '../components/Community/CommunityDashboard';

export const CommunityPage: React.FC = () => {
  return (
    <div className="h-full w-full p-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Community Engagement</h1>
          <p className="mt-2 text-gray-600">
            Join the community effort to expand urban forestry in Hackensack. Suggest new tree locations and track community progress.
          </p>
        </div>
        
        <CommunityDashboard />
      </div>
    </div>
  );
};
